<template>
  <b-card no-body class="shadow h-100 flex-container grid-stack-item-content">
    <div slot="header">
      <window-header cmp-title="Info tool" widget-name="info"></window-header>
    </div>
    <div class="flex-full-height row noselect p-3" >
      <b-col cols="5">
        <div class="flex-container">
          <div>
            <b-form-group id="filterLayerGroup" label-for="filterLayers">
              <b-form-input v-model="filterInfoKey" class="input-xs" id="filterLayers" type="text" placeholder="Type to filter layers">
                <b-button size="sm"><icon name="search" scale=".6" label="Filter layers"></icon></b-button>
              </b-form-input>
            </b-form-group>
          </div>
          <div class="info-tool-browser flex-full-height">
            <template v-for="item in $store.getters['map/infoLayerTree']">
              <info-tool-item :node="item"></info-tool-item>
            </template>
          </div>
        </div>
      </b-col>
      <b-col cols="7">
        <div class="flex-container">
          <div>
            <div class="bg-light p-2">
              <div class="d-flex justify-content-between">
                <div>
                  <span class="elevation-text">elevation: {{parseFloat(elevation).toFixed(1)}}</span>
                </div>
                <div class="float-right">
                  <b-btn variant="link" v-if="this.$store.getters['map/constraintPhotosId']" @click="openViewImages=true">View photos</b-btn>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-full-height">
            <b-tabs pills card class="info-details-tabs">
              <info-tool-details></info-tool-details>
              <!-- <b-tab no-body title="Details" active>
                <info-tool-details></info-tool-details>
              </b-tab> -->
              <!-- <b-tab no-body title="History">
                <info-history></info-history>
              </b-tab> -->
              <!-- <b-tab no-body title="Log">
                <InfoChangeLog></InfoChangeLog>
              </b-tab> -->
            </b-tabs>
          </div>
        </div>
      </b-col>
    </div>
    <window-footer></window-footer>
  </b-card>
</template>
<script>
  import InfoToolItem from './InfoTooltem.vue'
  import InfoToolDetails from './InfoToolDetails.vue'
  import InfoHistory from './InfoHistory.vue'
  import InfoChangeLog from './InfoChangeLog.vue'
  import 'vue-awesome/icons/search-plus'
  import MultiPoint from 'ol/geom/MultiPoint'
  import WindowHeader from '../../common/WindowHeader'
  import WindowFooter from '../../common/WindowFooter'

  export default {
    components: {
      WindowHeader,
      WindowFooter,
      InfoToolDetails,
      InfoToolItem,
      InfoHistory,
      InfoChangeLog
    },
    name: 'info-tool',
    computed: {
      filterInfoKey: {
        get () {
          return this.$store.getters['map/filterInfoKey']
        },
        set (val) {
          this.$store.commit('map/filterInfoKey', val)
        }
      }
    },
    data () {
      return {
        openViewImages: false,
        elevation: 0,
        searchTolerance: 5,
        cost_layers: []
      }
    },
    created () {
      this.currentItem = null
    },
    mounted () {
      this.$http.get('/api/layers/info-cost-layers')
        .then(res => {
          this.cost_layers = res.body.layers
        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not load info cost layers',
            type: 'error'
          })
        })

      this.bindClick()
    },
    destroyed () {
      this.unBindClick()
    },
    watch: {

    },
    methods: {
      setCurrentItem(root, override) {
        if (override || this.currentItem === null) {
          if (this.$store.getters['map/infoToolLine']) {
            let f = (c) => {
              if (this.currentItem) {
                return
              }
              if (!c.children && c.parentName && c.parentName === this.$store.getters['map/infoToolLine']) {
                this.currentItem = c
                this.$store.commit('map/currentInfoItem', this.currentItem)
                return
              } else {
                if (c.children && c.children.length) {
                  c.children.forEach(f)
                }
              }
            }
            (root.children || []).forEach(f)
          }

          let f = (c) => {
            if (this.currentItem) {
              return
            }
            if (!c.children) {
              this.currentItem = c
              this.$store.commit('map/currentInfoItem', this.currentItem)
              if (c.parentName) {
                this.$store.commit('map/infoToolLine', c.parentName)
              }
              return
            } else {
              if (c.children && c.children.length) {
                c.children.forEach(f)
              }
            }
          }
          (root.children || []).forEach(f)
        }
      },
      bindClick () {
        this.$mapService.addListener('click', this.onClick, this)
      },
      unBindClick () {
        this.$mapService.removeListener('click', this.onClick, this)
      },
      onClick (e) {
        this.$store.commit('map/setInfoLayerTree', [])
        let vec = this._collectVector(e.pixel)
        this.$store.commit('map/infoLayerTree', vec)
        this.setCurrentItem(vec, true)
        this.$store.commit('map/infoLayerTree', this._collectWms(e.pixel, e.coordinate))

        this.$http.get('/api/layers/get-elevation', {
          params: {
            point: `POINT(${e.coordinate.join(' ')})`
          }
        })
          .then(res => {
            this.elevation = res.body.elevation
          }, res => {
            console.error(res)
            this.$notify({
              title: 'ERROR',
              text: 'Could not get elevation',
              type: 'error'
            })
          })
      },
      _collectCostSurface (cord, node) {
        this.$mapService.loadCostSurfaceInfo(this.$store.getters['project/currentProject'].workpack.id, `POINT(${cord.join(' ')})`, node, n => this.setCurrentItem(n, false))
        return node
      },
      _collectVector (pixel) {
        let mapFeatureLayer = {}
        let data = []
        this.$mapService.map.forEachFeatureAtPixel(pixel, (f, l) => {
          let layerName = l.get('kegs_title')
          if (!mapFeatureLayer[layerName]) {
            mapFeatureLayer[layerName] = []
          }
          mapFeatureLayer[layerName].push(f)
        }, {hitTolerance: this.searchTolerance})

        for (let k in mapFeatureLayer) {
          if (mapFeatureLayer.hasOwnProperty(k)) {
            data.push({
              name: k,
              isLayer: true,
              children: mapFeatureLayer[k].map(f => {

                let props = f.getProperties()
                props.parentName = k
                let p1 = {...props}
                if (!p1['id'] && p1['objectid']) {
                  p1['id'] = p1['objectid']
                }

                let keysRemove = []
                for (let k in props) {
                  if (props.hasOwnProperty(k) && props[k] && props[k].getCoordinates) {
                    keysRemove.push(k)
                  }
                }
                keysRemove.forEach(key => Reflect.deleteProperty(p1, key))
                return p1
              })
            })
          }
        }

        return {
          name: 'Features',
          children: data
        }
      },
      _collectWms (pixel, cord) {
        let rawlayers = this.$mapService.getVisibleTileLayers()
        let ignore = this.cost_layers

        let layers = rawlayers.filter(l => {
          return !ignore.includes(l.get('kegs_name'))
        })

        let costNode = {
          name: 'Cost Surface',
          children: [],
          loading: true
        }
        // if (rawlayers.length > layers.length) {
        this.$store.commit('map/infoLayerTree', this._collectCostSurface(cord, costNode))
        // } else {
        //   store.commit('removeNodeInfoLayerTree', costNode)
        // }

        let rootNode = {
          name: 'Imagery',
          children: layers.map(layer => {
            let layerName = layer.get('kegs_name')
            let layerTitle = layer.get('kegs_title')
            return {
              title: layerTitle,
              name: layerName,
              isLayer: true,
              loading: false,
              children: []
            }
          })
        }
        let pixelBbox = [pixel[0] - this.searchTolerance, pixel[1] - this.searchTolerance, pixel[0] + this.searchTolerance, pixel[1] + this.searchTolerance]

        let bl = this.$mapService.map.getCoordinateFromPixel([pixelBbox[0], pixelBbox[1]])
        let tr = this.$mapService.map.getCoordinateFromPixel([pixelBbox[2], pixelBbox[3]])

        let geom = new MultiPoint([bl, tr])
        let bbox = geom.getExtent()

        this.$mapService.loadWmsFeatureInfo(rootNode, bbox, pixel, this.$store.getters['project/currentProject']['workpack']['id'], (node) => {
          this.currentItem = null
          this.setCurrentItem(node, false)
        })

        return rootNode
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/info/InfoTool.vue